<template>
	<main class="px-2 md:px-6">
		<section v-if="sahabat.status_upz !== null">
			<div class="flex mb-6">
				<h4><strong>Layanan ZIS</strong></h4>
			</div>
			<div id="content-data" class="flex w-full justify-center lg:justify-center">
				<router-link 
					v-for="(item, i) in category"
					:key="i"
					:to="getLink(item)" class="flex flex-col mx-2 md:mx-4 lg:mx-2"
				>
					<div class="mb-2">
						<img v-if="item.file === null" v-lazy="`/assets/images/donation/zakat.svg`" alt="" class="w-full md:w-32" />
						<img v-else v-lazy="item.file_url" alt="" class="w-full md:w-32" />	
					</div>
					<strong class="block text-center">{{item.name}}</strong>
				</router-link>
			</div>
		</section>		
	</main>
</template>
<script>
	export default {
		props: ['sahabat', 'user_id'],
		data: () => ({
			category: []
		}),
		methods: {
			getLink(item) {
				let url = `/bayar-zis?ft=${item.id}&t=${ item.name.split(' ').map(it => it.toLowerCase()).join('_') }&mt=${this.sahabat.user.id}`

				if(this.$route.params.referal) {
					url += `&ref=${this.$route.params.referal}`
				}

				return url
			}
		},
		beforeMount() {
			this.$vs.loading()
			this.$store.dispatch('getZisCategory', {
				user_id: this.user_id
			})
			.then(kategori => {
				this.$vs.loading.close()
				kategori.map(item => {
					item.file_url = null
					if(item.file !== null) {
						item.file_url = process.env.VUE_APP_STORAGE + '/' + item.file
					}
				})
				this.category = kategori
			})
			.catch(e => this.$vs.loading.close())
		}
	}
</script>
<style>
	.wow {
		width: 100% !important;
	}
	@media (min-width: 768px) {
		.wow {
			width: 9rem !important;
		}
	}
</style>